const initialState = [];

export const variaveisReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADICIONAR_VARIAVEL":
      return [...state, { nome: "", valor: "" }];
    case "REMOVER_VARIAVEL":
      return state.filter((_, index) => index !== action.payload);
    case "ATUALIZAR_VARIAVEL":
      return state.map((variavel, index) =>
        index === action.payload.index
          ? { ...variavel, [action.payload.campo]: action.payload.valor }
          : variavel
      );
    case "SET_VARIAVEIS":
      return action.payload || [];
    default:
      return state;
  }
};
